{
  "tabs": {
    "chat": "Obrolan",
    "reminders": "Pangeling",
    "calendar": "Kalénder",
    "settings": "Setélan"
  },
  "common": {
    "cancel": "Batal",
    "save": "Simpen",
    "confirm": "Konfirmasi",
    "delete": "Hapus",
    "back": "Balik",
    "close": "Tutup",
    "edit": "Édit",
    "search": "Pilarian",
    "all": "Sadaya",
    "loading": "Ngamuat...",
    "error": "Aya kasalahan",
    "notFound": "Henteu kapanggih",
    "tryAgain": "Coba deui",
    "retry": "Ulangi",
    "undo": "Batalkeun",
    "pullToRefresh": "Tarik pikeun ngapdet",
    "justNow": "barusan"
  },
  "auth": {
    "welcome": "Wilujeng sumping di FishMemory",
    "tagline": "Asisten pangeling WhatsApp anjeun, ayeuna aya dina saku.",
    "subtitle": "Asisten pangeling WhatsApp anjeun, ayeuna aya dina saku.",
    "phoneLabel": "Nomor WhatsApp anjeun",
    "phoneHint": "Kami bakal ngirim kode verifikasi via WhatsApp",
    "invalidPhone": "Mangga lebetkeun nomer telepon anu valid",
    "continue": "Teruskeun",
    "enterPhone": "Lebetkeun nomer WhatsApp anjeun",
    "phonePlaceholder": "Nomer telepon",
    "sendCode": "Kirim Kode",
    "verifyTitle": "Verifikasi nomer anjeun",
    "otpSentTo": "Kode 6-digit geus dikirim ka {{phone}} via WhatsApp",
    "enterFullCode": "Mangga lebetkeun sadaya 6 digit",
    "invalidOtp": "Kode teu valid. Coba deui.",
    "otpFailed": "Gagal ngirim kode. Coba deui.",
    "otpResent": "Kode geus dikirim deui",
    "resendIn": "Kirim deui dina {{seconds}}s",
    "resendCode": "Kirim deui kode",
    "enterOtp": "Lebetkeun kode anu dikirim ka WhatsApp anjeun",
    "verify": "Verifikasi",
    "resend": "Kirim deui kode",
    "wrongNumber": "Nomer salah?",
    "backToPhone": "Balik ka nomer",
    "editPhone": "Édit nomer telepon",
    "error": "Kasalahan",
    "setupTitle": "Hayu atur heula",
    "setupSubtitle": "Anjeun tiasa ngarobih ieu engké di Setélan",
    "namePlaceholder": "Nami anjeun",
    "letsGo": "Rampungkeun setélan",
    "skipForNow": "Léngkah heula"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Tulis pesen...",
    "inputPlaceholder": "Tulis pesen...",
    "typing": "FishMemory keur ngetik...",
    "online": "Online",
    "connecting": "Nyambung...",
    "reconnecting": "Nyambung deui...",
    "offline": "Offline",
    "empty": "Mimitian obrolan",
    "emptyHint": "Jieun pangeling, pariksa jadwal, atawa menta bantosan.",
    "emptyAction": "Kirim pangeling conto",
    "actions": "Aksi obrolan",
    "keep": "Simpen pesen",
    "clearTitle": "Bersihkeun obrolan",
    "clearConfirm": "Hapus sadaya pesen tina alat ieu? Ieu teu tiasa dibalikeun.",
    "clear": "Bersihkeun obrolan",
    "optionSelected": "Kapilih: {{label}}",
    "sendingSelection": "Ngirim...",
    "connectionLost": "Nyambung deui..."
  },
  "reminders": {
    "title": "Pangeling Kuring",
    "active": "Aktif",
    "today": "Dinten ieu",
    "thisWeek": "Minggu Ieu",
    "history": "Sajarah",
    "items": "item",
    "emptyTitle": "Teu aya pangeling",
    "emptySubtitle": "Jieun tina obrolan sareng bakal mucunghul di dieu.",
    "emptyAction": "Buka obrolan",
    "filterActive": "Aktif",
    "filterToday": "Dinten ieu",
    "filterWeek": "Minggu Ieu",
    "filterHistory": "Sajarah",
    "emptyState": "Teu aya pangeling. Mimitian ngobrol!",
    "swipeDone": "Réngsé",
    "swipeSnooze": "Tunda",
    "swipeDelete": "Hapus",
    "search": "Pilarian pangeling...",
    "upcoming": "Anu bakal datang",
    "completed": "Réngsé",
    "overdue": "Telat",
    "tomorrow": "Isukan",
    "synced": "Disinkronkeun {{value}}",
    "swipeHint": "Geser pangeling pikeun aksi leuwih",
    "noResults": "Teu aya pangeling cocog pilarian",
    "noResultsHint": "Coba kecap konci séjén atawa bersihkeun pilarian",
    "deleteAllFailed": "Gagal ngahapus sadaya pangeling"
  },
  "calendar": {
    "title": "Kalénder",
    "today": "Dinten ieu",
    "tomorrow": "Isukan",
    "completed": "réngsé",
    "noEvents": "Henteu aya jadwal",
    "noEventsSubtitle": "Pilih tanggal pikeun ningali pangeling jeung acara kalénder.",
    "googleEvent": "Kalénder Google",
    "legendActive": "Aktif",
    "legendRecurring": "Balik deui",
    "legendDone": "Réngsé",
    "legendGoogle": "Google",
    "previousMonth": "Bulan kamari",
    "nextMonth": "Bulan payun",
    "previousYear": "Taun kamari",
    "nextYear": "Taun payun",
    "goToToday": "Ka dinten ieu",
    "all": "Sadaya",
    "active": "Aktif",
    "done": "Réngsé",
    "paused": "Dijeda"
  },
  "settings": {
    "title": "Setélan",
    "profile": "Profil",
    "name": "Nami Tampilan",
    "enterName": "Lebetkeun nami anjeun",
    "language": "Basa",
    "uiLanguage": "Basa aplikasi",
    "uiLanguageHelp": "Ngarobih UI aplikasi, labél kalénder, jeung arah tata letak dina alat ieu wungkul.",
    "serverLanguage": "Basa obrolan",
    "serverLanguageHelp": "Ngarobih basa anu dipaké ku balesan server jeung pesen pangeling pikeun akun anjeun.",
    "timezone": "Zona waktu",
    "currentTimezone": "Zona waktu ayeuna",
    "timezoneHelp": "Sadaya waktos pangeling ditampilkeun nganggo zona waktu ieu.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Simpen zona waktu",
    "timezoneSaved": "Zona waktu diropéa",
    "detect": "Deteksi",
    "detectFailed": "Gagal ngadeteksi zona waktu",
    "autoDetect": "Deteksi otomatis tina GPS",
    "notifications": "Bewara",
    "notificationsHelp": "Pangeling tindak lanjut ngatur bewara ulang sanggeus pangeling dikirim. Izin bewara tingkat alat masih diatur dina setélan telepon anjeun.",
    "pushEnabled": "Bewara Push",
    "autoDoneOnFire": "Tandaan réngsé otomatis nalika dipicu",
    "autoDoneOnFireDesc": "Lamun pareum, pangeling tetep aktif nepi ka anjeun nandaan réngsé.",
    "googleCalendar": "Kalénder Google",
    "google": "Kalénder Google",
    "googleConnected": "Nyambung",
    "googleDisconnected": "Henteu nyambung",
    "googleConnectedHelp": "Pangeling anyar bisa disinkronkeun otomatis kana kalénder anjeun.",
    "googleDisconnectedHelp": "Sambungkeun Kalénder Google pikeun nyaluyukeun pangeling jeung acara.",
    "googleConnectFailed": "Gagal nyambung Kalénder Google",
    "connected": "Nyambung",
    "disconnected": "Henteu nyambung",
    "connect": "Sambungkeun",
    "disconnect": "Putuskeun",
    "autoSync": "Sinkron otomatis pangeling anyar",
    "autosync": "Sinkron otomatis pangeling anyar",
    "subscription": "Langganan",
    "trialUsed": "Trial: {{used}}/{{total}} dipaké",
    "trialStatus": "Trial aya",
    "activeStatus": "Langganan aktif",
    "expiredStatus": "Langganan kadaluwarsa",
    "unsubscribedStatus": "Henteu langganan",
    "about": "Ngeunaan",
    "version": "Versi",
    "logout": "Kaluar",
    "logoutTitle": "Kaluar",
    "logoutConfirm": "Yakin rék kaluar?",
    "noName": "Nami teu disetél",
    "serverConnection": "Sambungan server",
    "serverUrl": "URL server",
    "serverEdit": "Édit",
    "saveReconnect": "Simpen jeung sambung deui",
    "resetDefault": "Balikeun ka standar",
    "invalidServerUrlTitle": "URL server teu valid",
    "invalidServerUrlMessage": "Lebetkeun URL server http atawa https anu valid, contona https://example.com",
    "uiLanguageChangeFailed": "Gagal ngarobih basa aplikasi. Coba deui.",
    "serverLanguageChangeFailed": "Gagal ngarobih basa obrolan. Coba deui.",
    "timezoneChangeFailed": "Gagal ngarobih zona waktu. Coba deui.",
    "autoSyncChangeFailed": "Gagal ngapdet sinkron otomatis. Coba deui.",
    "nameChangeFailed": "Gagal ngapdet nami tampilan. Coba deui.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Rincian pangeling",
    "editTime": "Édit Waktos",
    "rename": "Ganti nami",
    "snooze": "Tunda",
    "snooze15": "Tunda 15 menit",
    "pause": "Jeda",
    "pauseReminder": "Jeda pangeling",
    "resume": "Lanjutkeun",
    "resumeReminder": "Lanjutkeun pangeling",
    "skip": "Léngkah Salajengna",
    "skipOccurrence": "Léngkah kajadian ieu",
    "syncGoogle": "Sinkron ka Google",
    "delete": "Hapus",
    "deleteTitle": "Hapus Pangeling",
    "deleteConfirm": "Pangeling ieu bakal dihapus permanén.",
    "deleteRecurringTitle": "Hapus Pangeling Balik deui",
    "deleteRecurringMessage": "Naha rék léngkah kajadian ieu atawa hapus sadaya séri?",
    "deleteThisOccurrence": "Léngkah Kajadian Ieu",
    "deleteEntireSeries": "Hapus Sadaya Séri",
    "done": "Réngsé",
    "markDone": "Tandaan réngsé",
    "undo": "Balikeun",
    "undoPrompt": "Perlu deui aktip? Balikeun ayeuna.",
    "recurring": "Balik deui",
    "nextRun": "Léngkah salajengna",
    "oneTime": "Sakali",
    "pending": "Nunggu",
    "sent": "Dikirim",
    "paused": "Dijeda",
    "active": "Aktif",
    "snoozed": "Ditunda",
    "localTime": "Ditampilkeun dina waktos lokal anjeun",
    "recurrence": "Balik deui",
    "created": "Dijieun",
    "tags": "Tag",
    "fireCount": "Kali dipicu",
    "actions": "Aksi",
    "none": "Henteu aya",
    "snoozeFailed": "Gagal nunda pangeling",
    "pauseFailed": "Gagal jeda pangeling",
    "resumeFailed": "Gagal lanjutkeun pangeling",
    "skipFailed": "Gagal léngkah pangeling",
    "doneFailed": "Gagal nandaan pangeling réngsé",
    "undoFailed": "Gagal balikeun status pangeling",
    "deleteFailed": "Gagal ngahapus pangeling",
    "rescheduleTitle": "Atur deui?",
    "rescheduleMsg": "Pangeling ieu geus telat. Naha rék atur deui?",
    "reschedule15": "Dina 15 menit",
    "reschedule60": "Dina 1 jam",
    "keepOverdue": "Tetepkeun sakumaha aya"
  },
  "onboarding": {
    "slide1Title": "Wilujeng sumping di FishMemory",
    "slide1Sub": "Asisten pangeling pribadi anjeun — didukung ku WhatsApp jeung didamel pikeun saku anjeun.",
    "slide2Title": "Ngobrol Wajar Wae",
    "slide2Sub": "Tulis pangeling sakumaha anjeun mikir: \"Ingetkeun kuring nelepon indung isukan jam 3 sore\" — kami ngurus sésana.",
    "slide3Title": "Teu Kaluputan",
    "slide3Sub": "Nampi bewara pas waktuna, atur ku tag, jeung tetep ngawas sagala hal penting.",
    "getStarted": "Mimitian",
    "next": "Saterusna",
    "firstReminderTitle": "Jieun pangeling kahiji anjeun!",
    "firstReminderHint": "Coba tulis sapertos:",
    "firstReminderExample": "Ingetkeun kuring nginum cai isukan jam 9 énjing",
    "gotIt": "Ngartos!",
    "notifRationaleTitle": "Tetep Tepat Waktu",
    "notifRationaleBody": "FishMemory peryogi bewara pikeun ngélingkeun anjeun pas waktuna. Anjeun ngan bakal nampi bewara pikeun pangeling anu anjeun jieun.",
    "notifRationaleAllow": "Aktipkeun Bewara",
    "notifRationaleLater": "Mungkin Engké",
    "swipeHint": "Geser ka katuhu pikeun aksi gancang →",
    "calendarDragHint": "Sered pikeun ngalegaan ↕"
  }
}
